import { apiRequest } from './client';

export interface StoredDocument {
  id: string;
  mimeType: string;
  sizeBytes: number;
}

export async function uploadDocument(file: File): Promise<StoredDocument> {
  const form = new FormData();
  form.append('file', file);
  return apiRequest<StoredDocument>('/api/documents', { method: 'POST', body: form });
}

export function documentUrl(id: string): string {
  return `/api/documents/${id}`;
}
